<div class="row invalid-login-container">
  <div class="container container-fluid">
    <div class="col-sm-12">
      <p style="color: #605ca8; font-size: 16px" [innerHTML]=getMessage()></p>
      <a style="color: #0067b8; cursor: pointer;" (click)="backToLogin()">Back to Login</a>
    </div>
  </div>
</div>
